/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const orderReviewCreateRequestSchema = z
	.object({
		score: z.int().min(1).max(5),
		comment: z.string().nullish(),
	})
	.describe("Входные данные отзыва о заказе из UI.");
